import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/footer/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/header/Header.tsx");
